// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"c9a62686","351":"af74b46b","964":"af74b46b"}[chunkId] + ".chunk.css";
};